export default "__VITE_ASSET__1060605a__"